import angular from 'angular';
import simpleFilters from './filters.simple';

let filters = angular.module('shared.filters', [])
  .filter('capitalize', simpleFilters.capitalize)
  .filter('s4bCurrency', simpleFilters.s4bCurrency)
  .filter('fileSize', simpleFilters.fileSize)
  .filter('ngEnter', simpleFilters.ngEnter)
  .filter('b2bModalSelect', simpleFilters.b2bModalSelect)
  .filter('textFilterFilter', simpleFilters.textFilterFilter);

export default filters;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/filters/filters.js
 **/